import { render, staticRenderFns } from "./fbp.vue?vue&type=template&id=e6cfa552&scoped=true"
import script from "./fbp.vue?vue&type=script&lang=js"
export * from "./fbp.vue?vue&type=script&lang=js"
import style0 from "./fbp.vue?vue&type=style&index=0&id=e6cfa552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cfa552",
  null
  
)

export default component.exports